import { useMemo } from 'react';
import useCookies from './useCookies';
var usePrebasketToggle = function usePrebasketToggle() {
  var _useCookies = useCookies(),
    abtestPrebasket = _useCookies.abtestPrebasket;
  return useMemo(function () {
    return abtestPrebasket === 'B';
  }, [abtestPrebasket]);
};
export default usePrebasketToggle;